import {
    Rating,
    Button,
    IconButton
} from "@mui/material";
import { HighlightOff } from "@mui/icons-material";
import { H6, Body3 } from "../../../../../themes/typography";
import "../../../../../styles/user-dashboard/PendingReviewCard.css"

const thumbnail = 'https://images.unsplash.com/photo-1514464750060-00e6e34c8b8c?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';


export default function PendingReviewCard({
    eventName = "Music Concert 2025",
    rating = 2.0,
    img = thumbnail,
    onShareReviewClick = () => { },
    onDismissClick = () => { }
}) {
    return (
        <div className="pending-event-review-card-container">
            <div className="pending-event-review-card-wrapper">

                <div className="pending-event-review-card-thumbnail">
                    <img src={img} alt="Event Thumbnail" />
                </div>

                <div className="pending-event-review-card-details">

                    <div className="pending-review-event-name-rating">
                        <div className="pending-review-event-name">
                            <H6>{eventName}</H6>
                            <IconButton
                                disableTouchRipple
                                sx={{
                                    padding: '0',
                                    color: 'var(--error-main-color)',
                                    '&:hover': {
                                        color: 'var(--error-main-color)'
                                    }
                                }}
                            >
                                <HighlightOff color="inherit" />
                            </IconButton>
                        </div>
                        <div className="pending-review-event-rating">
                            <div className="pending-review-event-rating-value">
                                <Body3 fontWeight={400}>
                                    {rating}
                                </Body3>
                            </div>
                            <div className="pending-review-event-rating-stars">
                                <Rating
                                    name="event-rating"
                                    value={rating}
                                    max={5}
                                    readOnly
                                    precision={0.25}
                                    sx={{
                                        fontSize: '1.25rem',
                                        color: 'var(--secondary-color)',
                                        '& .MuiRating-icon': {
                                            color: 'var(--secondary-color)'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="pending-review-event-action-btn">
                        <Button
                            variant="lightToggleActiveSm"
                            disableTouchRipple
                            onClick={onShareReviewClick}
                            sx={{
                                border: 'none',
                                minWidth: '0',
                                padding: '0',
                                color: 'var(--tertiary-color)',
                                '&:hover': {
                                    color: 'var(--tertiary-color)'
                                }
                            }}
                        >
                            Share Review
                        </Button>

                        {/* <Button
                            variant="lightToggleActiveSm"
                            disableTouchRipple
                            onClick={onDismissClick}
                            sx={{
                                border: 'none',
                                minWidth: '0',
                                padding: '0',
                                color: 'var(--error-main-color)',
                                '&:hover': {
                                    color: 'var(--error-main-color)'
                                }
                            }}
                        >
                            Dismiss
                        </Button> */}
                    </div>

                </div>

            </div>
        </div>
    )
}